export const montos = {
  2019: 0.1,
  2020: 0.2,
  2021: 0.3,
  2022: 0.4,
  2023: 0.5
}

// export default montos